exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#juryModalChangeCategory {\n  padding-right: 0 !important;\n  display: block;\n  font-family: \"FranklinGothicMediumITC\";\n  color: #5A5652;\n}\n#juryModalChangeCategory .modal-dialog .modal-content .modal-header {\n  border-bottom: none;\n}\n#juryModalChangeCategory .modal-dialog .modal-content .modal-body .category-ok-image {\n  width: 120px;\n  height: 120px;\n}\n", ""]);

// exports
